export default __webpack_public_path__ + "static/media/image.63ca3600.svg";